var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27664_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.2562C17.2574 17.6817 14.0572 20.1665 10.2766 20.1665C5.61352 20.1665 1.83334 16.3863 1.83334 11.7232C1.83334 7.94264 4.3181 4.7424 7.74362 3.6665",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.087 9.11849C19.1139 5.63251 16.3677 2.88625 12.8817 1.91316C11.375 1.49259 10.0833 2.79984 10.0833 4.36406V10.5007C10.0833 11.2828 10.7174 11.9168 11.4995 11.9168H17.6361C19.2003 11.9168 20.5076 10.6251 20.087 9.11849Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27664_3306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceDark);
export default __webpack_public_path__ + "static/media/FinanceDark.06530cd9e70462cfceaf0fc9064bcda1.svg";
export { ForwardRef as ReactComponent };